import httpRequest from '@/api/request'

type IQueryExistsItem = {
  search_type:
    | 'block'
    | 'hub_transaction'
    | 'checkin_transaction'
    | 'account'
    | 'module_account'
    | null
}

/**
 * @description 判断用户搜索的是区块、交易还是地址
 * @param key
 */
export const queryExists = (key: string): Promise<{ existence_check: IQueryExistsItem[] }> => {
  return httpRequest.get(`/api/rest/query_exists`, {
    params: {
      key,
    },
  })
}
